import axios from 'axios';
import { Auth, API } from 'aws-amplify';

// import AWS from 'aws-sdk';

import awsConfig from '@/aws-exports.js';

import {getEnvVar} from '@/library/utils/env-vars';

const IdentityPoolId = getEnvVar('IdentityPoolId')
	, _PROVIDER = getEnvVar('_PROVIDER');

import * as suscripcionUtils from '@/library/suscripcion';

import * as asyncConfig from '@/async-config';
import { federatedSignIn, logout, refreshToken } from '@/library/utils/aws-signing';
import { clearCache } from '@/library/utils/cacheSystem';

export default {
	async signIn({commit, dispatch, state, rootState}, payload={}){

		commit('auth_init');

		state.isloading = true;
		let username = payload.username;
		let clave = payload.pass;
		const opts = payload.opts;
		let {versionCheckeada = false} = payload

		let token = null;
		let identityId = null;
		let sii_token = null;
		let user = null

		try{
			if(!versionCheckeada)
				await dispatch('version/checkVersion', null, { root: true })
		}catch(err){
			state.isloading = false;
			return false;
		}

		let jwt = {}

		try{

			let resp = await siiLogin(username, clave, opts);
			
			if(resp.estado == 3){
				throw resp.glosa;
			}

			identityId = resp.openId.IdentityId;
			token = resp.openId.Token;
			jwt = resp.jwt;
			user = resp.user;

			sii_token = resp.sii_token;
		}catch(err){
			console.error(err)
			let error = err.response;

			if( error != null ){
				let {data={}}=error;
				if( data.estado != null && data.estado != 0 ){
					error = data.glosa;
				}
			}else{
				error = 'Ha ocurrido un error, vuelva a intentarlo más tarde.'
			}
			
			commit('auth_error', error)
			return error
		}

		let token_backend = !token? false: token || false;

		if(!!token_backend){

			try{

				let exp = 6*60*60*1000;

				if( user != null ){
					exp = user.expires_in;
				}

				let expireTime = new Date().getTime() + exp;

				let authToken = {
					token:token,
					identity_id: identityId, // Optional
					expires_at: expireTime // the expiration timestamp
				}

				let signinResp = await federatedSignIn(authToken, user, jwt)

				let currentAuthenticatedUser = await Auth.currentAuthenticatedUser();

				commit('auth_success', {user:user.username, token:sii_token, identityId});
				
				try {
					await asyncConfig.actualizar();
				}
				catch(err) {
					
				}
				
				// Suscribirse a notificaciones
				await suscripcionUtils.suscribir();
				
				return await Auth.currentAuthenticatedUser();
			}catch(err){
				commit('auth_error', err);
				return err;
			}
		}

		return false;
	},
	async signOut({commit, dispatch, rootState}, callback=null){

		let resp = null;

		clearCache();

		try{
			resp = await logout();
			
			// Desuscribirse de notificaciones
			suscripcionUtils.desuscribir();
		}catch(err){
			resp = err;
		}

		rootState.empresas.selected = undefined;

		await dispatch('version/resetEstados', {}, { root: true });

		if(!!callback)	callback(resp);

		return resp;
	},
	async getSession(){

		let resp = null;
		try{
			resp = await Auth.currentAuthenticatedUser()
		}catch(err){
			resp = err;
		}
		return resp;
	},
	// retornar Promise
	async getCurrentUser({commit, state}){

		if( !state.username ){
			let {username, id} = await Auth.currentAuthenticatedUser()
			let payload = {user:username, token:null, identityId:id};
			commit('auth_success', payload);
			return username;
		}

		return state.username;
	},
	// retornar Promise
	refreshToken({commit, dispatch, state, rootState}, callback){
		dispatch('getCurrentUser').then(credentials=>{

			let username = credentials.username;
			let identityId = credentials.identityId;
			
			dispatch('getRefreshedToken', username,identityId).then(response=>{
				return new Promise((res, rej) => {
					const data = {
						token: response.token, // the token from the provider
						expires_at: response.expires_at, // the timestamp for the expiration
						identity_id: response.identity_id, // optional, the identityId for the credentials
					}

					let token = response.token;
					let newIdentityId = response.identity_id;

					dispatch('generateCredentials', token, newIdentityId);

					res(data);
				})
			}).catch(err=>{
				
				throw err;
			})

		}).catch(err=>{
			
			throw err;
		})
	},
	// retornar promise
	getRefreshedToken({state}, {user, identityId}){

		let params = {
			body:{
				user: user,
				identityId: identityId,
			}
		};

		return API.post('apiAuthSII', '/refresh-token', params);
	},
	developerSignIn({commit, dispatch, state}, {username,identityId, token, expireTime}){

		commit('auth_success', username, state.siiToken, identityId);

		let expiresAt = new Date(expireTime).getTime();

		return Auth.federatedSignIn(
			'developer',
			{
				token:token,
				identity_id: identityId, // Optional
				expires_at: expiresAt // the expiration timestamp
			},
			{
				username,
				identityId,
				expires_at: expiresAt,
				token
			}
		);
	},
	onSessionExpired({commit, state}, err){

		commit('auth_expired', err);
		window.location.replace('/');
	},
	async eventoActualizarContribuyente({dispatch, rootGetters}, payload){
		let currentUser = await Auth.currentAuthenticatedUser({
			bypassCache: false  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
		});

		let user = currentUser.username;

		let contribuyente = rootGetters['empresas/selectedRut'];

		let init = {
			body:{
				usuario:user
			}
		};

		let path = `/evento/actualizar/contribuyente/${contribuyente}`;
			let api = 'eBoletaActualizador';
		
		let resp = await API.post(api, path, init);

		dispatch('getCantidadActualizacionesDiarias');
	},
	async getCantidadActualizacionesDiarias({commit, rootGetters}, payload){
		let currentUser = await Auth.currentAuthenticatedUser({
			bypassCache: false  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
		});

		let user = currentUser.username;

		let contribuyente = rootGetters['empresas/selectedRut'];

		let path = `/evento/actualizar/contribuyente/${contribuyente}`;
		let api = 'eBoletaActualizador';

		let init = {
			queryStringParameters:{
				usuario:user
			}
		}
		
		let resp = await API.get(api, path, init);

		commit('ACT_CANTIDAD', resp);
	}
}
// retornar promise
async function siiLogin(username, clave, opts=null){

	let params = {
		body:{
			rut: username.split('-')[0],
			dv: username.split('-')[1],
			clave
			,opts
		}
	};

	let apiname = 'apiAuthSII';
	let apipath = '/sign-in';

	try{
		// se valida el usuario y contraseña para
		// SII y de obtiene el identity id para el usuario
		let resp = await API.post(apiname, apipath, params);
		return resp;
	}catch(err){
		
		throw err;
	}
}